import io from "socket.io-client";

export default {
	setSystemStateSocket(payload, callback) {
		const socket = io(process.env.VUE_APP_URL);

		socket.emit("join_room", "system_state");
		socket.emit("send_data", payload);

		socket.on("receive_data", (data) => {
			if (callback) callback(data);
		});
	},

	setSystemControlSocket(payload, callback) {
		const socket = io(process.env.VUE_APP_URL);

		socket.emit("join_room", "system_control");
		socket.emit("send_data", payload);

		socket.on("receive_data", (data) => {
			if (callback) callback(data);
		});
	},

	setSystemFirmwareSocket(payload, callback) {
		const socket = io(process.env.VUE_APP_URL);

		socket.emit("join_room", "system_firmware");
		socket.emit("send_data", payload);

		socket.on("receive_data", (data) => {
			if (callback) callback(data);
		});
	},

	setSystemModeSocket(payload, callback) {
		const socket = io(process.env.VUE_APP_URL);

		socket.emit("join_room", "system_mode");
		socket.emit("send_data", payload);

		socket.on("receive_data", (data) => {
			if (callback) callback(data);
		});
	},

	setSystemZoneSocket(payload, callback) {
		const socket = io(process.env.VUE_APP_URL);

		socket.emit("join_room", "system_zone");
		socket.emit("send_data", payload);

		socket.on("receive_data", (data) => {
			if (callback) callback(data);
		});
	},

	setSystemsCommonSocket(payload, callback) {
		const socket = io(process.env.VUE_APP_URL);

		socket.emit("join_room", "systems_common");
		socket.emit("send_data", payload);

		socket.on("receive_data", (data) => {
			if (callback) callback(data);
		});
	},
};
